import { el, setAttr } from 'redom';

import OutsideClickEventRegistration from 'lib/outside-click-event-registration';

import HelptapColorPicker from 'generics/components/color-picker-native';

import {
  displayElementAroundAnchor
} from 'utilities/element-position';

import ShadowForm from './form';

import './index.scss';

class ShadowInputPanel {

  constructor(configuration) {

    this.value = configuration.value;
    this.onChange = configuration.onChange;
    this.onClose = configuration.onClose;
    this.outsideEventRegistration = null;

    this.form = new ShadowForm({
      value: this.value,
      onChange: (value) => {
        let actualValue = value;
        if (typeof value === 'string') {
          actualValue = +value.replace('px', '');
        }
        this.handleWidthChange(actualValue);
      }
    });
    this.colorPicker = new HelptapColorPicker({
      color: this.value.color,
      onChange: (color) => this.handleColorChange(color)
    });

    this.el = el('.shadow-input-panel-main', [this.form, this.colorPicker]);

  }

  handleWidthChange(width) {

    this.value.width = width;

    this.onChange(this.value);

  }

  handleColorChange(color) {

    this.value.color = color;

    this.onChange(this.value);

  }

  position() {

    const element = this.el;
    const anchorElement = element.parentNode;
    const viewportElement = void 0;
    const verticalOffset = 45;
    const horizontalOffset = 0;
    const startSide = 'top';
    const placeOnCenter = true;
    const positionableSides = void 0;

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);
    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  onmount() {

    this.outsideEventRegistration = new OutsideClickEventRegistration(this.el, this.onClose);

    this.position();

  }

  onunmount() {

    this.outsideEventRegistration.cancel();

  }

}

export default ShadowInputPanel;